// Защита от бесконечного цикла запросов /pickpoints. Любая успешная (непустая) загрузка сбрасывает счётчик.
export const MAX_PICKPOINT_ATTEMPTS = 3

const pickpointAttempts = new Map()

export function getPickpointAttempts(city) {
  return pickpointAttempts.get(city) || 0
}

export function incrementPickpointAttempts(city) {
  pickpointAttempts.set(city, getPickpointAttempts(city) + 1)
}

export function resetPickpointAttempts(city) {
  if (city === undefined) {
    pickpointAttempts.clear()
    return
  }
  pickpointAttempts.delete(city)
}

export function filterPickpoints(
  items,
  search,
  filteredTypes = [],
  fields = ['ADDRESS', 'NAME', 'EMAIL']
) {
  if (!items || !Array.isArray(items)) return []
  let result = filteredTypes.length
    ? items.filter((el) => filteredTypes.includes(el.TYPE))
    : items

  if (!search) return result

  const normalizedSearch = normalizeString(search.toLowerCase())

  return result.filter((item) =>
    fields.some(
      (field) =>
        item[field] &&
        normalizeString(item[field].toLowerCase()).includes(normalizedSearch)
    )
  )
}

export function normalizeString(str) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

export function getPickPointAddress(pickpoint, getCountryCode) {
  return (
    (pickpoint.CITY &&
    pickpoint.CITY.length &&
    !pickpoint.ADDRESS.includes(pickpoint.CITY) &&
    pickpoint.TYPE !== 'I_UA_NEW_POST'
      ? pickpoint.CITY + ','
      : '') +
    pickpoint.ADDRESS.replace(/<\/?[^>]+(>|$)/g, ' ') +
    (getCountryCode === 'FI' || getCountryCode === 'EE'
      ? ', ' + pickpoint.NAME
      : '')
  )
}
